import Vue from "vue";
import ResourceService from "./resource.service";

class TemporaryResourcesRequestService extends ResourceService {
  static get resource() {
    return "temporary-resources-request";
  }
}

export default TemporaryResourcesRequestService;
